const psikologi: any = {
	relationship: {
		title: 'Informasi Asmara Terlengkap',
		description:
			'Baca informasi lengkap seputar tips percintaan dan menjalin keharmonisan hubungan ' +
			'asmara antara pasangan hanya di KlikDokter.',
	},
	'kesehatan-mental': {
		title: 'Informasi Kesehatan Mental Terlengkap',
		description:
			'Informasi lengkap seputar kesehatan jiwa serta jenis gangguan mental, ' +
			'seperti bipolar, depresi, gangguan kecemasan, gangguan tidur dan skizofrenia.',
	},
	'psikologi-keluarga': {
		title: 'Informasi Psikologi Keluarga Terlengkap',
		description:
			'Baca informasi lengkap seputar hubungan antar anak dan orangtua, ' +
			'sesama anggota keluarga, serta kerabat hanya di KlikDokter.',
	},
};

export default psikologi;
